var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mw-panel"},[_c('toolbar-table',{ref:"viewToolbarTable",attrs:{"pagination":_vm.pagination,"limit":_vm.limit,"layout":_vm.layout}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f561c7c4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/index/views/componentRevision/index.vue
// module id = 1296
// module chunks = 0 1